import type React from "react";

import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { JointAcademyLogo, LogoIcon } from "assets";

interface Props {
  fullLogo?: boolean;
  className?: string;
}

export const Logo: React.FC<Props> = ({ fullLogo, className }) => {
  return (
    <Stack direction="row" alignItems="center" flex={0} className={className}>
      <Link to="/dashboard">{fullLogo ? <StyledJointAcademyLogo /> : <StyledLogo />}</Link>
    </Stack>
  );
};

const StyledLogo = styled(LogoIcon)`
  max-width: 44px;
  max-height: 44px;
  width: 44px;
  height: 44px;
`;

const StyledJointAcademyLogo = styled(JointAcademyLogo)`
  width: auto;
  height: 32px;
`;
